module.exports = __webpack_public_path__ + "res/25-img_bg_l.610f4ad5bfb3e04b8cf1c5bdd7bb31ee.png";